import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COUNTRY_INFO } from '../../constans/countries/countries';
import styles from './styles.module.css'
import { setPassportWithSync } from './reducer';


export const PassportSelector = () => {
    const dispatch = useDispatch();

    const passport = useSelector(
        state => state.settings.passport
    );

    const [isOpen, setIsOpen] = useState(false);

    const selectedCountry = passport
        ? COUNTRY_INFO[passport]
        : null;

    const handleSelect = (countryId) => {
        dispatch(setPassportWithSync(countryId));
        setIsOpen(false);
    };

    return (
        <div className={styles.root}>
            <button
                className={styles.selector}
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedCountry ? (
                    <>
                        <span className={styles.country_flag}>{selectedCountry.flag}</span>
                        <span>{selectedCountry.name}</span>
                    </>
                ) : (
                    <span>Select your passport</span>
                )}

                <span className={styles.arrow}>
                    {isOpen ? '↑' : '↓'}
                </span>
            </button>

            {isOpen && (
                <div className={styles.countryList}>
                    {Object.entries(COUNTRY_INFO).map(
                        ([id, country]) => (
                            <button
                                key={id}
                                className={styles.country}
                                onClick={() => handleSelect(id)}
                            >
                                <span className={styles.country_flag}>{country.flag}</span>
                                <span>{country.name}</span>
                            </button>
                        )
                    )}
                </div>
            )}

        </div>
    );
};